import styled from '@emotion/styled';

export const CardContainer = styled.div`
  padding: 4rem 2.4rem;
	display: flex;
	flex-direction: column;
	justify-content: center; /* 중앙 정렬 */
	align-items: center; /* 가로 가운데 */
	cursor: pointer;
	gap: 2rem; /* 이미지-텍스트 상하 간격 확대 */
  width: 100%; /* 부모 컬럼 너비에 맞추어 균일한 가로폭 보장 */
	// border: 1px solid #e9ecef;
	border-right: none;
	border-bottom: none;

	:nth-of-type(3),
	:nth-of-type(6) {
		// border-right: 1px solid #e9ecef;
	}
	:nth-of-type(4),
	:nth-of-type(5),
	:nth-of-type(6) {
		// border-bottom: 1px solid #e9ecef;
	}
	@media screen and (max-width: 1100px) {
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 2rem; /* 태블릿: 내부 여백 약간 축소 */
		border-right: none;
		border-bottom: none;
		:nth-of-type(4) {
			border-left: none;
			border-bottom: none;
		}
		:nth-of-type(2),
		:nth-of-type(4),
		:nth-of-type(6) {
			// border-right: 1px solid #e9ecef;
		}
		:nth-of-type(5),
		:nth-of-type(6) {
			border-bottom: 1px solid #e9ecef;
		}
	}
	@media screen and (max-width: 420px) {
		gap: 1.2rem; /* 모바일: 요소 간 간격 축소 */
		padding: 1.6rem; /* 모바일: 내부 여백 축소 */
		border-bottom: none;
		:nth-of-type(1),
		:nth-of-type(5) {
			// border-right: 1px solid #e9ecef;
		}
		:nth-of-type(4) {
			border-left: 1px solid #e9ecef;
		}
		:nth-of-type(5) {
			border-bottom: none;
		}
		:last-child {
			border-bottom: 1px solid #e9ecef;
		}
	}
`;
